import React, { useState, useEffect } from "react";
import Row from "./Row";
import ComingSoonRow from "./ComingSoonRow";
import FooterTop from "../FooterTop";
import { ref as dRef, onValue } from "firebase/database";
import { db, getMobileMode, fetchCurrentUser } from "./../../firebase";
import "./Home.css";

import FormBox from "../form/FormBox";
import { useAddress, useNetworkMismatch } from "@thirdweb-dev/react";
import { useNavigate } from "react-router-dom";
import MintPopUp from "./../popup/MintPopUp";
import ProductionRow from "./ProductionRow";
import ProductionPop from "./../popup/ProductionPop";
import CountdownBanner from "./CountdownBanner";

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

const Home = () => {
  let navigate = useNavigate();
  const networkMismatch = useNetworkMismatch();
  const [concertData, setConcertData] = useState();
  const firstReleaseConcerts = [126, 114, 118, 116];
  const trendingConcerts = [8, 2, 4, 6, 10];
  const concerts = [5, 4, 7, 2];
  const [currentUser, setCurrentUser] = useState(null);
  const [userData, setUserData] = useState();
  const [pageMobileMode, setPageMobileMode] = useState(false);

  useEffect(() => {
    setPageMobileMode(getMobileMode());
  }, [networkMismatch]);

  //set current user
  useEffect(() => {
    setCurrentUser(fetchCurrentUser());
  }, []);

  //download User Data
  useEffect(() => {
    if (currentUser) {
      var userDataRef = dRef(db, "users/" + currentUser.user.uid);
      onValue(userDataRef, (snapshot) => {
        var data = snapshot.val();
        setUserData(data);
      });
    }
  }, [currentUser]);
  //get concert data
  useEffect(() => {
    var concertDataRef = dRef(db, "concerts/");
    onValue(concertDataRef, (snapshot) => {
      var cData = snapshot.val();
      setConcertData(cData);
    });
  }, []);

  const [showMintPopUp, setShowMintPopUp] = useState(false);
  const [singleConcert, setSingleConcert] = useState(126);

  const [showProductionPop, setShowProductionPop] = useState(false);
  const [productionID, setProductionID] = useState(0);

  return (
    <>
      {concertData && (
        <div className="home__page">
          {showMintPopUp && (
            <MintPopUp
              currentUser={currentUser}
              concertData={concertData[singleConcert]}
              concertID={singleConcert}
              setShowMintPopUp={setShowMintPopUp}
              setCurrentUser={setCurrentUser}
            />
          )}
          {showProductionPop && (
            <ProductionPop
              currentUser={currentUser}
              productionID={productionID}
              setProductionID={setProductionID}
              setShowProductionPop={setShowProductionPop}
              setCurrentUser={setCurrentUser}
            />
          )}
          <CountdownBanner
            setShowMintPopUp={setShowMintPopUp}
            concertData={concertData}
            concertID={126}
          />
          <Row
            title="NFT Concerts Minting Now"
            isLargeRow
            concertData={concertData}
            concerts={firstReleaseConcerts}
            singleConcert={singleConcert}
            setSingleConcert={setSingleConcert}
            setShowMintPopUp={setShowMintPopUp}
          />
          <ProductionRow
            setShowProductionPop={setShowProductionPop}
            productionID={productionID}
            setProductionID={setProductionID}
            intro="Go Backstage"
          />
          <ComingSoonRow
            title="Upcoming Shows"
            concertData={concertData}
            concerts={concerts}
            isFinalRow
          />
          <div className="row__gradient__blend" />
          <FooterTop />
        </div>
      )}
    </>
  );
};

export default Home;
